/**
 * Formats a date string into a readable format with time.
 * @param {string | Date} date - The date to format.
 * @param {string} locale - The locale to use for formatting (default: 'ro-RO').
 * @param {object} options - Additional Intl.DateTimeFormat options.
 * @returns {string} - The formatted date string.
 */
export const formatDate = (date, locale = "ro-RO", options = {}) => {
    if (!date) return "N/A"; // Handle null or undefined dates

    try {
        const dateObj = typeof date === "string" ? new Date(date) : date;
        return new Intl.DateTimeFormat(locale, {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit", // Add hour
            minute: "2-digit", // Add minute
            hour12: false, // Use 24-hour format (set to true for 12-hour format)
            ...options,
        }).format(dateObj);
    } catch (error) {
        console.error("Error formatting date:", error);
        return "Invalid Date";
    }
};